// extracted by mini-css-extract-plugin
export var block = "index-module--block--Ce8O5";
export var buttonBox = "index-module--buttonBox--oM2wg";
export var container = "index-module--container--jm2ky";
export var downloadButton = "index-module--downloadButton--LASKZ";
export var gradBorder = "index-module--gradBorder---0tth";
export var resources = "index-module--resources--UPL88";
export var subtext = "index-module--subtext--QiGzB";
export var text = "index-module--text--v8wXJ";
export var textSection = "index-module--textSection--rnhK2";